'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = tuneInApi;

var _forOwn = require('lodash/forOwn');

var _forOwn2 = _interopRequireDefault(_forOwn);

var _createApiContext = require('./createApiContext');

var _createApiContext2 = _interopRequireDefault(_createApiContext);

var _wrapper = require('./utils/reauth/wrapper');

var _wrapper2 = _interopRequireDefault(_wrapper);

var _reauth = require('./services/reauth');

var _reauth2 = _interopRequireDefault(_reauth);

var _auth = require('./services/auth');

var _auth2 = _interopRequireDefault(_auth);

var _browse = require('./services/browse');

var _browse2 = _interopRequireDefault(_browse);

var _config = require('./services/config');

var _config2 = _interopRequireDefault(_config);

var _favorites = require('./services/favorites');

var _favorites2 = _interopRequireDefault(_favorites);

var _logging = require('./services/logging');

var _logging2 = _interopRequireDefault(_logging);

var _profile = require('./services/profile');

var _profile2 = _interopRequireDefault(_profile);

var _redirectInfo = require('./services/redirectInfo');

var _redirectInfo2 = _interopRequireDefault(_redirectInfo);

var _reports = require('./services/reports');

var _reports2 = _interopRequireDefault(_reports);

var _subscription = require('./services/subscription');

var _subscription2 = _interopRequireDefault(_subscription);

var _tune = require('./services/tune');

var _tune2 = _interopRequireDefault(_tune);

var _cms = require('./services/cms');

var _cms2 = _interopRequireDefault(_cms);

var _infoMessages = require('./services/infoMessages');

var _infoMessages2 = _interopRequireDefault(_infoMessages);

var _metrics = require('./services/metrics');

var _metrics2 = _interopRequireDefault(_metrics);

var _partners = require('./services/partners');

var _partners2 = _interopRequireDefault(_partners);

var _alexa = require('./services/alexa');

var _alexa2 = _interopRequireDefault(_alexa);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var serviceCreators = {
  auth: _auth2.default,
  alexa: _alexa2.default,
  browse: _browse2.default,
  config: _config2.default,
  favorites: _favorites2.default,
  logging: _logging2.default,
  profile: _profile2.default,
  redirectInfo: _redirectInfo2.default,
  reports: _reports2.default,
  subscription: _subscription2.default,
  tune: _tune2.default,
  cms: _cms2.default,
  infoMessages: _infoMessages2.default,
  metrics: _metrics2.default,
  partners: _partners2.default
};

function tuneInApi(config, requestHeaders, onTrackingEvent) {
  var apiContext = (0, _createApiContext2.default)(config, requestHeaders, onTrackingEvent);
  var reauth = (0, _reauth2.default)(config, apiContext);
  var applyReauth = (0, _wrapper2.default)(reauth, apiContext);

  var services = {
    reauth: reauth
  };

  (0, _forOwn2.default)(serviceCreators, function (serviceCreator, name) {
    services[name] = serviceCreator(config, apiContext, applyReauth);
  });

  return _extends({
    setTokens: apiContext.setTokens,
    getTokens: apiContext.getTokens,
    setCookies: apiContext.setCookies,
    enableGraphQl: apiContext.enableGraphQl
  }, services);
}
//# sourceMappingURL=tuneInApi.js.map